// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, signInWithPopup, GoogleAuthProvider,  OAuthProvider} from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBgEgsT4ik0iGfAouIgcQeKkZJTcXxMz-I",
  authDomain: "xianhe-e5671.firebaseapp.com",
  projectId: "xianhe-e5671",
  storageBucket: "xianhe-e5671.firebasestorage.app",
  messagingSenderId: "1045065321916",
  appId: "1:1045065321916:web:0204f49d251c26df962fb9",
  measurementId: "G-7VMFS45EG6"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialize Firebase Auth provider
const provider = new GoogleAuthProvider();
// Force account selection when interacting with the provider
provider.setCustomParameters({ prompt: "select_account" });

export const auth = getAuth(firebaseApp); // Pass the initialized app to getAuth
export const signInWithGooglePopup = () => signInWithPopup(auth, provider);
export const storage = getStorage(firebaseApp);


